export default __webpack_public_path__ + "static/media/AIG dark.d7c73f73.svg";